import React from 'react';
import Pricing from '../components/sections/Pricing';

const PricingPage: React.FC = () => {
  return (
    <main className="pt-20 sm:pt-24">
      {/* Hero Section */}
      <section className="section-padding bg-white">
        <div className="container-custom text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium text-gray-900 mb-4 sm:mb-6">
            Pricing & Packages
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Transparent pricing for all our services. Choose the perfect package for your business needs and budget.
          </p>
        </div>
      </section>

      {/* Pricing Section */}
      <Pricing />

      {/* FAQ Section */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-medium text-gray-900 mb-3 sm:mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto px-4">
              Get answers to common questions about our pricing and services
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
              <div className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-gray-200">
                <h3 className="text-lg sm:text-xl font-normal text-gray-900 mb-3 sm:mb-4">What's included in each package?</h3>
                <p className="text-sm sm:text-base text-gray-600">
                  Each package includes different levels of design concepts, revisions, file formats, and delivery time. 
                  Check the detailed features list above for each package.
                </p>
              </div>

              <div className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-gray-200">
                <h3 className="text-lg sm:text-xl font-normal text-gray-900 mb-3 sm:mb-4">Can I upgrade my package later?</h3>
                <p className="text-sm sm:text-base text-gray-600">
                  Yes! You can upgrade to a higher package at any time. We'll apply your previous payment 
                  towards the new package price.
                </p>
              </div>

              <div className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-gray-200">
                <h3 className="text-lg sm:text-xl font-normal text-gray-900 mb-3 sm:mb-4">Do you offer custom packages?</h3>
                <p className="text-sm sm:text-base text-gray-600">
                  Absolutely! We can create custom packages tailored to your specific needs and budget. 
                  Contact us to discuss your requirements.
                </p>
              </div>

              <div className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-gray-200">
                <h3 className="text-lg sm:text-xl font-normal text-gray-900 mb-3 sm:mb-4">What payment methods do you accept?</h3>
                <p className="text-sm sm:text-base text-gray-600">
                  We accept all major credit cards, bank transfers, and digital payment methods. 
                  Payment is typically required before we begin work.
                </p>
              </div>

              <div className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-gray-200">
                <h3 className="text-lg sm:text-xl font-normal text-gray-900 mb-3 sm:mb-4">How long does delivery take?</h3>
                <p className="text-sm sm:text-base text-gray-600">
                  Delivery times vary by package: Starter (3-5 days), Professional (5-7 days), 
                  Premium (7-10 days). Rush delivery is available for an additional fee.
                </p>
              </div>

              <div className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-gray-200">
                <h3 className="text-lg sm:text-xl font-normal text-gray-900 mb-3 sm:mb-4">Do you provide source files?</h3>
                <p className="text-sm sm:text-base text-gray-600">
                  Yes! All packages include source files in various formats. Premium package includes 
                  Adobe Illustrator files for complete customization.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-white">
        <div className="container-custom text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-medium text-gray-900 mb-4 sm:mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
            Choose your package or contact us for a custom quote. We're here to help bring your vision to life.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
            <button className="bg-brand-blue text-white px-6 sm:px-8 py-2 sm:py-3 rounded-lg font-normal hover:bg-brand-orange transition-all duration-300 text-sm sm:text-base">
              Choose Package
            </button>
            <button className="bg-white text-brand-blue border-2 border-brand-blue px-6 sm:px-8 py-2 sm:py-3 rounded-lg font-normal hover:bg-brand-blue hover:text-white transition-all duration-300 text-sm sm:text-base">
              Get Custom Quote
            </button>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PricingPage;
